import React from 'react';
import { Link } from 'react-router-dom';

type PublicLabCourseNoteProps = {
  courseSlug?: string | null;
  courseTitle?: string | null;
  className?: string;
};

/** Shown on public labs (Labs catalog) to point learners to the related self-paced course. */
const PublicLabCourseNote: React.FC<PublicLabCourseNoteProps> = ({ courseSlug, courseTitle, className = '' }) => {
  if (!courseSlug) return null;
  return (
    <p className={`text-sm text-gray-600 ${className}`.trim()}>
      To deep dive into related concepts and access the complete course, join our self-paced course here:{' '}
      <Link to={`/courses/${courseSlug}`} className="font-semibold text-primary-700 hover:text-primary-800">
        {courseTitle || 'Open the course'}
      </Link>
    </p>
  );
};

export default PublicLabCourseNote;
